/* ongod studio — theme behaviour. No dependencies. */
(function () {
  'use strict';
  var cfg = window.ogConfig || {};
  var CREDIT = cfg.credit || [[500000, 50000], [1000000, 100000]];

  function rs(cents) { var v = cents / 100; return '\u20B9' + v.toLocaleString('en-IN', { minimumFractionDigits: (cents % 100 ? 2 : 0), maximumFractionDigits: 2 }); }
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function lock(on) { document.body.classList.toggle('og-locked', !!on); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function raf(fn) { setTimeout(fn, 16); }
  function creditFor(sub) { var c = 0; CREDIT.forEach(function (t) { if (sub >= t[0]) c = t[1]; }); return c; }

  /* ---------- menu ---------- */
  function toggleMenu(force) {
    var open = typeof force === 'boolean' ? force : !document.body.classList.contains('og-menu-open');
    document.body.classList.toggle('og-menu-open', open);
  }

  /* ---------- gallery slider ---------- */
  function bindSlider(track, nEl, dotWrap) {
    if (!track) return;
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (nEl) nEl.textContent = (i + 1) + ' / ' + track.children.length;
      if (dotWrap) qa('i', dotWrap).forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }, { passive: true });
  }

  /* ---------- size guide ---------- */
  function bindGuide() {
    var ov = q('.og-sg');
    if (!ov) return;
    function open(o) { ov.classList.toggle('is-open', o); lock(o); }
    qa('[data-og-guide-open]').forEach(function (b) { b.addEventListener('click', function () { open(true); }); });
    qa('[data-og-guide-close]', ov).forEach(function (b) { b.addEventListener('click', function () { open(false); }); });
    var bg = q('.og-ov__bg', ov);
    if (bg) bg.addEventListener('click', function () { open(false); });
    qa('[data-og-unit]', ov).forEach(function (b) {
      b.addEventListener('click', function () {
        var cm = b.getAttribute('data-og-unit') === 'cm';
        qa('[data-og-unit]', ov).forEach(function (x) { x.setAttribute('aria-pressed', (x === b) ? 'true' : 'false'); });
        qa('[data-in]', ov).forEach(function (td) { var inch = parseFloat(td.getAttribute('data-in')); td.textContent = cm ? (Math.round(inch * 2.54 * 10) / 10) : inch; });
        var lb = q('[data-og-unit-label]', ov); if (lb) lb.textContent = cm ? 'cm' : 'inches';
      });
    });
    qa('[data-og-sg-size]', ov).forEach(function (tr) {
      tr.addEventListener('click', function () {
        var want = tr.getAttribute('data-og-sg-size');
        var btn = qa('[data-og-product] .og-size').filter(function (b) { return b.textContent.trim() === want && !b.disabled; })[0];
        if (btn) btn.click();
        open(false);
      });
    });
    function hi() {
      var cur = q('[data-og-product] .og-size[aria-checked="true"]');
      var want = cur ? cur.textContent.trim() : '';
      qa('[data-og-sg-size]', ov).forEach(function (tr) { tr.style.background = tr.getAttribute('data-og-sg-size') === want ? '#F4F4F4' : 'transparent'; });
    }
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.og-size')) setTimeout(hi, 0); });
    hi();
  }

  /* ---------- variants ---------- */
  function bindVariants(root) {
    var idInput = q('[name="id"]', root);
    var priceEl = q('[data-og-price]', root);
    var atc = qa('[data-og-atc],[data-og-buy]', root);
    qa('.og-size', root).forEach(function (btn) {
      if (btn.hasAttribute('disabled')) return;
      btn.addEventListener('click', function () {
        qa('.og-size', root).forEach(function (b) { b.setAttribute('aria-checked', b === btn ? 'true' : 'false'); });
        if (idInput) idInput.value = btn.getAttribute('data-vid');
        var p = btn.getAttribute('data-vprice');
        if (priceEl && p) priceEl.textContent = 'RS. ' + Math.round(parseInt(p, 10) / 100).toLocaleString('en-IN');
        var sp = q('[data-og-sticky-price]');
        if (sp && p) sp.textContent = rs(parseInt(p, 10));
        atc.forEach(function (b) { b.disabled = false; });
      });
    });
  }

  /* ---------- payment plan ---------- */
  function bindPay(root) {
    var box = q('[data-og-pay]', root); if (!box) return;
    var opts = qa('.og-pay__o', box), buy = q('[data-og-buy]', root), plan = 'full', MON = 6, ADV = 0.3;
    var r = function (paise) { return '\u20B9' + Math.round(paise / 100).toLocaleString('en-IN'); };
    var d = new Date();
    qa('[data-og-month]', box).forEach(function (el) { var i = +el.getAttribute('data-og-month'); el.textContent = i === 0 ? 'Today' : new Date(d.getFullYear(), d.getMonth() + i, 1).toLocaleString('en', { month: 'short' }); });
    function price() { var on = q('.og-size[aria-checked="true"]', root), v = on && on.getAttribute('data-vprice'); return v ? parseInt(v, 10) : (parseInt(box.getAttribute('data-price'), 10) || 0); }
    function set(k, v) { qa('[data-og-amt="' + k + '"]', box).forEach(function (el) { el.textContent = v; }); }
    function sync() {
      var p = price(), emi = p / MON, now = Math.round(p / 10);
      set('full', r(p)); set('emi', r(emi)); set('codnow', r(now)); set('codrest', r(p - now));
      opts.forEach(function (o) { var on = o.getAttribute('data-plan') === plan; o.classList.toggle('is-on', on); o.setAttribute('aria-checked', on ? 'true' : 'false'); });
      if (buy && !buy.classList.contains('is-buying')) buy.textContent = plan === 'emi' ? 'BUY NOW \u00B7 ' + r(emi) + '/MO' : plan === 'cod' ? 'PLACE ORDER \u00B7 PAY ' + r(now) : 'BUY NOW';
    }
    opts.forEach(function (o) { o.addEventListener('click', function () { plan = o.getAttribute('data-plan'); sync(); }); });
    qa('.og-size', root).forEach(function (b) { b.addEventListener('click', function () { setTimeout(sync, 0); }); });
    sync();
  }
  function savePlan(root) {
    var on = root && q('.og-pay__o.is-on', root), lbl = on && on.getAttribute('data-label');
    if (!lbl) return Promise.resolve();
    return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Payment plan': lbl } }) }).catch(function () {});
  }

  /* ---------- tote zoom ---------- */
  function bindTote() {
    var z = q('[data-og-tote]');
    if (!z) return;
    function open(o) { z.classList.toggle('is-open', o); lock(o); }
    qa('[data-og-tote-open]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); open(true); }); });
    z.addEventListener('click', function () { open(false); });
  }

  /* ---------- sticky ATC (mobile) ---------- */
  function bindStickyAtc() {
    var wrap = q('[data-og-product] .og-satc'), mark = q('[data-og-product] [data-og-satc-mark]');
    if (!wrap || !mark) return;
    var sync = function () { wrap.classList.toggle('is-on', mark.getBoundingClientRect().top < window.innerHeight - 14); };
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ---------- Styled carousel ---------- */
  function bindWear(root) {
    var tile = q('.og-wear__tile', root), figs = qa('.og-wear__fig', root), LN = figs.length;
    if (!tile || !LN) return;
    var step = Math.PI * 2 / LN, R = 47 / Math.sin(Math.min(step, Math.PI / 3)), FADE = 1.4, rot = 0, drag = false;
    var scene = root.getAttribute('data-scene') || 'desert', sceneImg = q('.og-wear__scene', root);
    var scenes = {}; try { scenes = JSON.parse(root.getAttribute('data-scenes') || '{}'); } catch (e) {}
    var tops = { hills: -15.6, desert: -19.5, cracked: -9 };
    var px = null, pr = 0, pw = 300, moved = false, pt = 0;
    function render() {
      var sc3 = scene !== 'studio';
      figs.forEach(function (f, i) {
        var a = (i * step - rot) % (Math.PI * 2); if (a > Math.PI) a -= Math.PI * 2; if (a < -Math.PI) a += Math.PI * 2;
        var au = Math.abs(a) / step, d = (Math.cos(a) + 1) / 2, t = 1 - d, fade = Math.max(0, Math.min(1, (FADE - au) / 0.7));
        var x = Math.sin(a) * R, sc = 0.62 + 0.38 * d, bo = 0.55;
        f.style.left = (50 + x) + '%';
        f.style.zIndex = 100 - Math.round(au * 40);
        f.style.opacity = fade * (bo + (1 - bo) * d);
        f.style.filter = sc3
          ? 'blur(' + (t * 3.2).toFixed(2) + 'px) brightness(' + (1 + 0.22 * t).toFixed(3) + ') contrast(' + (1 - 0.3 * t).toFixed(3) + ') saturate(' + (1 - 0.35 * t).toFixed(3) + ')'
          : 'blur(' + (t * 2.5).toFixed(2) + 'px) brightness(' + (0.9 + 0.1 * d).toFixed(3) + ')';
        f.style.transform = 'translate(-50%,' + (-t * 1.5).toFixed(2) + '%) scale(' + sc.toFixed(4) + ')';
        f.style.pointerEvents = au > 1.5 ? 'none' : 'auto';
      });
      tile.classList.toggle('is-drag', drag);
    }
    function setScene(id) {
      scene = id; var sc3 = id !== 'studio';
      tile.classList.toggle('is-scene', sc3);
      if (sceneImg) { if (sc3 && scenes[id]) { sceneImg.src = scenes[id]; sceneImg.style.top = (tops[id] != null ? tops[id] : -15) + '%'; } }
      qa('.og-wear__sc', root).forEach(function (b) { var on = b.getAttribute('data-scene') === id; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
      render();
    }
    function goLook(k) { rot = k * step; drag = false; render(); }
    function go(dir) { goLook(Math.round(rot / step) + dir); }
    tile.addEventListener('pointerdown', function (e) { px = e.clientX; pr = rot; pw = tile.clientWidth || 300; moved = false; pt = Date.now(); try { tile.setPointerCapture(e.pointerId); } catch (x) {} });
    tile.addEventListener('pointermove', function (e) { if (px == null) return; var dx = e.clientX - px; if (Math.abs(dx) > 5) moved = true; if (!moved) return; rot = pr - dx / pw * step * 1.6; drag = true; render(); });
    function up(e) {
      if (px == null) return; var dx = e.clientX - px, dt = Math.max(1, Date.now() - pt); px = null;
      if (!moved) { drag = false; render(); return; }
      var k = Math.round(rot / step), v = dx / dt;
      if (k === Math.round(pr / step) && Math.abs(v) > 0.3) k += v < 0 ? 1 : -1;
      goLook(k); setTimeout(function () { moved = false; }, 0);
    }
    tile.addEventListener('pointerup', up); tile.addEventListener('pointercancel', up);
    figs.forEach(function (f, i) {
      f.addEventListener('click', function () {
        if (moved) return;
        var k = Math.round(rot / step), base = k - ((k % LN) + LN) % LN, cand = [base + i, base + i - LN, base + i + LN];
        cand.sort(function (p, qq) { return Math.abs(p - k) - Math.abs(qq - k); });
        goLook(cand[0]);
      });
    });
    tile.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') go(-1); else if (e.key === 'ArrowRight') go(1); });
    var L = q('[data-og-wear-prev]', root), Rb = q('[data-og-wear-next]', root);
    if (L) L.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    if (Rb) Rb.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    qa('.og-wear__sc', root).forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); setScene(b.getAttribute('data-scene')); }); });
    setScene(scene);
  }

  /* ---------- cart ---------- */
  var drawer = q('.og-cart');
  var upsellData = []; try { var ud = q('[data-og-upsell-data]'); if (ud) upsellData = JSON.parse(ud.textContent); } catch (e) {}
  var totes = {}; try { var td = q('[data-og-totes]'); if (td) totes = JSON.parse(td.textContent); } catch (e) {}
  var BAG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 8h12l1 13H5zM9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  var TOTE_PROP = { 'Printed tote': 'Free on prepaid orders, same artwork' };
  var SZ = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  var pick = {}, lastCart = null, prevPaperH = 0, printT = 0;

  function openCart(o) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', o);
    document.body.classList.toggle('og-cart-open', o);
    lock(o);
    if (o) fetchCart();
    else { var tray = q('[data-og-tray]', drawer); if (tray) { tray.style.transition = 'none'; tray.style.height = '0px'; prevPaperH = 0; } }
  }

  function printReceipt() {
    var tray = q('[data-og-tray]', drawer), paper = q('[data-og-paper]', drawer), box = q('.og-printer', drawer);
    if (!tray || !paper) return;
    var target = drawer.classList.contains('is-open') ? paper.scrollHeight + 10 : 0;
    if (target === prevPaperH) return;
    var delta = target - prevPaperH;
    clearTimeout(printT);
    if (target === 0) { tray.style.transition = 'none'; paper.style.transition = 'none'; tray.style.height = '0px'; paper.style.transform = 'none'; prevPaperH = 0; return; }
    if (delta < 0) { tray.style.transition = 'height .3s ease'; paper.style.transition = 'none'; paper.style.transform = 'none'; tray.style.height = target + 'px'; prevPaperH = target; return; }
    var dur = Math.max(0.8, Math.min(3.4, delta / 95)), steps = Math.max(10, Math.round(delta / 5)), tr = dur + 's steps(' + steps + ', end)';
    tray.style.transition = 'none'; paper.style.transition = 'none';
    tray.style.height = prevPaperH + 'px'; paper.style.transform = 'translateY(' + (-delta) + 'px)';
    void tray.offsetHeight;
    raf(function () { raf(function () {
      tray.style.transition = 'height ' + tr; paper.style.transition = 'transform ' + tr;
      tray.style.height = target + 'px'; paper.style.transform = 'translateY(0px)';
      if (box) box.classList.add('is-printing');
      var led = q('[data-og-led-text]', drawer); if (led) led.textContent = 'PRINTING';
      printT = setTimeout(function () { if (box) box.classList.remove('is-printing'); if (led) led.textContent = 'READY'; }, dur * 1000 + 150);
    }); });
    prevPaperH = target;
  }

  function renderUpsell(cart) {
    var wrap = q('[data-og-up]', drawer), rail = q('[data-og-up-rail]', drawer);
    if (!wrap || !rail) return;
    var inCart = {}; cart.items.forEach(function (it) { inCart[it.product_id] = 1; });
    var sub = cart.total_price, credit = creditFor(sub);
    var lastSize = cart.items.length ? (cart.items[cart.items.length - 1].variant_title || 'M') : 'M';
    var list = upsellData.filter(function (p) { return p.available && !inCart[p.id]; }).slice(0, 6);
    if (!cart.item_count || !list.length) { wrap.hidden = true; return; }
    wrap.hidden = false;
    var next = null; for (var i = 0; i < CREDIT.length; i++) { if (sub < CREDIT[i][0]) { next = CREDIT[i]; break; } }
    var head = q('[data-og-up-head]', drawer); if (head) head.textContent = next ? 'Add ' + rs(next[0] - sub) + ' more \u2192 ' + rs(next[1]) + ' credit' : 'Complete the run';
    var szl = q('[data-og-up-size]', drawer); if (szl) szl.textContent = lastSize;
    rail.innerHTML = list.map(function (p) {
      var sz = pick[p.id] || lastSize;
      var after = creditFor(sub + p.price), unlock = after > credit;
      var sizes = p.variants.map(function (v) { return v.size; });
      var vSel = p.variants.filter(function (v) { return v.size === sz; })[0];
      if (!vSel || !vSel.available) { vSel = p.variants.filter(function (v) { return v.available; })[0]; if (vSel) sz = vSel.size; }
      return '<div class="og-upc" data-pid="' + p.id + '">' +
        '<a href="' + esc(p.url) + '" class="og-st-tile og-upc__tile" data-og-cart-close>' +
          (p.img ? '<img class="og-st-aura og-st-aura--card" src="' + esc(p.img) + '" alt=""><div class="og-st-glass"></div><div class="og-st-glare"></div><div class="og-st-rim"></div><img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
          '</a>' +
        '<div class="og-upc__m"><span class="og-upc__n">' + esc(p.title) + '</span><span class="og-upc__p">' + rs(p.price) + '</span>' +
          (unlock ? '<span class="og-upc__u">Unlocks ' + rs(after) + ' credit</span>' : '') + '</div>' +
        '<div class="og-upc__sz">' + p.variants.map(function (v) {
          return '<button type="button" data-og-up-size-pick="' + esc(v.size) + '" aria-pressed="' + (v.size === sz) + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.size) + '</button>';
        }).join('') + '</div>' +
        '<button type="button" class="og-upc__add" data-og-up-add="' + (vSel ? vSel.id : '') + '"' + (vSel ? '' : ' disabled') + '>ADD \u00B7 SIZE ' + esc(sz) + '</button>' +
      '</div>';
    }).join('');
  }

  function render(cart) {
    if (!drawer) return;
    cart = viewCart(cart);
    lastCart = cart;
    drawer.setAttribute('data-count', cart.item_count);
    var label = cart.item_count ? (cart.item_count === 1 ? '1 item' : cart.item_count + ' items') : '';
    qa('[data-og-count]', drawer).forEach(function (el) { el.textContent = label; });
    qa('[data-og-cart-count]').forEach(function (el) { el.textContent = cart.item_count; if (cart.item_count) el.removeAttribute('data-zero'); else el.setAttribute('data-zero', ''); });
    window.ogCartCount = cart.item_count;

    var lines = q('[data-og-lines]', drawer);
    if (lines) {
      lines.innerHTML = cart.items.map(function (item, i) {
        var img = (item.handle && (item.handle.indexOf('sweet-tooth') > -1 || item.handle === 'babel') && cfg.sweetImg) ? cfg.sweetImg : (item.image ? item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_300x$1$2') : '');
        return '<div class="og-line">' +
          '<div class="og-line__img og-st-tile">' + (img ? '<img class="og-st-aura og-st-aura--card" src="' + img + '" alt=""><div class="og-st-glass"></div><img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div style="min-width:0"><p class="og-line__n">' + esc(item.product_title) + '</p>' +
            '<p class="og-line__v">' + (item.variant_title ? 'Size ' + esc(item.variant_title) + ' \u00B7 ' : '') + '260 GSM</p>' +
            '<div class="og-qty"><button type="button" aria-label="Decrease" data-og-line="' + item._line + '" data-og-qty="' + (item.quantity - 1) + '">\u2212</button><span>' + item.quantity + '</span><button type="button" aria-label="Increase" data-og-line="' + item._line + '" data-og-qty="' + (item.quantity + 1) + '">+</button></div></div>' +
          '<div class="og-line__r"><button class="og-rm" type="button" aria-label="Remove" data-og-line="' + item._line + '" data-og-qty="0"><svg width="10" height="10" viewBox="0 0 14 14" fill="none" style="transform:rotate(45deg)"><path d="M7 1.6v10.8M1.6 7h10.8" stroke="#9A9A9A" stroke-width="1.4" stroke-linecap="round"/></svg></button>' +
            '<span class="og-line__p">' + rs(item.line_price) + '</span></div>' +
          '<div class="og-line__tote">' + (toteImg(item.product_id) ? '<span class="og-line__tth"><img src="' + esc(toteImg(item.product_id)) + '" alt="" loading="lazy"></span>' : '<span class="og-line__tth">' + BAG + '</span>') +
            '<span class="og-line__tt">+ ' + item.quantity + ' printed tote' + (item.quantity > 1 ? 's' : '') + ', same artwork, when you pay online</span><b>FREE</b></div></div>';
      }).join('');
    }
    var tr = q('[data-og-totes-row]', drawer), tn = q('[data-og-totes-n]', drawer);
    if (tr) tr.hidden = !cart.item_count;
    if (tn) tn.textContent = 'FREE TOTES ON PREPAID \u00D7' + cart.item_count;

    var sub = cart.total_price, credit = creditFor(sub);
    var next = null; for (var i = 0; i < CREDIT.length; i++) { if (sub < CREDIT[i][0]) { next = CREDIT[i]; break; } }
    var tiers = q('[data-og-tiers]', drawer);
    if (tiers) tiers.innerHTML = CREDIT.map(function (t) {
      var hit = sub >= t[0], near = !hit && sub >= t[0] / 2;
      return '<div class="og-ptier' + (hit ? ' is-hit' : near ? ' is-near' : '') + '">' + (hit ? '<svg viewBox="0 0 24 24"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>' : '') + rs(t[1]) + ' credit <span>at ' + rs(t[0]) + '</span></div>';
    }).join('');
    var bar = q('[data-og-credit-bar]', drawer); if (bar) bar.style.width = Math.min(100, Math.round(sub / CREDIT[CREDIT.length - 1][0] * 100)) + '%';
    var note = q('[data-og-credit-note]', drawer); if (note) note.textContent = next ? 'Add ' + rs(next[0] - sub) + ' more for ' + rs(next[1]) + ' store credit' : rs(credit) + ' store credit unlocked';
    qa('[data-og-sub]', drawer).forEach(function (el) { el.textContent = rs(sub); });
    var cc = q('[data-og-credit-cell]', drawer); if (cc) { cc.textContent = credit > 0 ? '+' + rs(credit) : '\u2014'; cc.classList.toggle('is-on', credit > 0); cc.classList.toggle('is-off', credit === 0); }
    var cb = q('[data-og-credit-back]', drawer); if (cb) { cb.hidden = credit === 0; cb.textContent = ' \u00B7 ' + rs(credit) + ' credit back'; }

    var empty = q('[data-og-empty]', drawer), foot = q('[data-og-foot]', drawer);
    if (empty) empty.hidden = !!cart.item_count;
    if (foot) foot.style.display = cart.item_count ? 'flex' : 'none';
    renderUpsell(cart);
    raf(printReceipt);
  }

  /* ---------- printed totes: one ₹0 tote product per tee, synced to the tee quantity ---------- */
  function toteImg(pid) { var T = cfg.totes || {}; return (T[pid] && T[pid].img) || totes[pid] || ''; }
  function toteVs() { var o = {}, T = cfg.totes || {}; Object.keys(T).forEach(function (k) { o[T[k].v] = 1; }); return o; }
  function viewCart(cart) {
    var TV = toteVs(), items = [], n = 0;
    (cart.items || []).forEach(function (it, i) { if (TV[it.variant_id]) return; var c = {}; for (var k in it) c[k] = it[k]; c._line = i + 1; items.push(c); n += it.quantity; });
    var v = {}; for (var k2 in cart) v[k2] = cart[k2]; v.items = items; v.item_count = n; return v;
  }
  function syncTotes(cart) {
    var T = cfg.totes || {}, TV = toteVs();
    if (!cart || !cart.items || !Object.keys(TV).length) return Promise.resolve(cart);
    var want = {}, have = {}, upd = {}, dirty = false;
    cart.items.forEach(function (it) {
      if (TV[it.variant_id]) { have[it.variant_id] = (have[it.variant_id] || 0) + it.quantity; return; }
      var t = T[it.product_id]; if (t && cfg.toteInCart) want[t.v] = (want[t.v] || 0) + it.quantity;
    });
    Object.keys(TV).forEach(function (v) { var w = want[v] || 0, h = have[v] || 0; if (w !== h) { upd[v] = w; dirty = true; } });
    if (!dirty) return Promise.resolve(cart);
    return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: upd }) })
      .then(function (r) { return r.json(); }).then(function (c) { return c && c.items ? c : cart; }).catch(function () { return cart; });
  }
  function fetchCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(syncTotes).then(render).catch(function () {}); }
  function change(line, qty) {
    return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(syncTotes).then(render);
  }
  function addToCart(id, qty, btn, then) {
    if (!id) return Promise.resolve();
    if (btn) { btn.disabled = true; btn.setAttribute('data-busy', '1'); }
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty || 1, properties: TOTE_PROP }] }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Add failed'); return d; }); })
      .then(function () { if (then) then(); else openCart(true); })
      .catch(function (err) { console.warn('[ongod] add to cart failed:', err.message); window.location.href = '/cart'; })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('data-busy'); } });
  }
  window.ogCart = { open: function () { openCart(true); }, close: function () { openCart(false); }, refresh: fetchCart, add: addToCart };

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-og-menu]')) { e.preventDefault(); toggleMenu(); return; }
    if (t.closest('[data-og-menu-close]')) { e.preventDefault(); toggleMenu(false); return; }
    if (t.closest('[data-og-cart-open]')) { e.preventDefault(); openCart(true); return; }
    if (t.closest('a[data-og-cart-close]')) { openCart(false); return; }
    if (t.closest('[data-og-cart-close]')) { e.preventDefault(); openCart(false); return; }
    if (drawer && drawer.classList.contains('is-open') && t.classList.contains('og-ov__bg') && t.closest('.og-cart')) { openCart(false); return; }
    var qb = t.closest('[data-og-qty]');
    if (qb) { change(parseInt(qb.getAttribute('data-og-line'), 10), parseInt(qb.getAttribute('data-og-qty'), 10)); return; }
    if (t.closest('[data-og-feed]')) { prevPaperH = 0; var tray = q('[data-og-tray]', drawer); if (tray) { tray.style.transition = 'none'; tray.style.height = '0px'; } setTimeout(printReceipt, 60); return; }
    var sp = t.closest('[data-og-up-size-pick]');
    if (sp && !sp.disabled) { var card = sp.closest('.og-upc'); pick[card.getAttribute('data-pid')] = sp.getAttribute('data-og-up-size-pick'); if (lastCart) renderUpsell(lastCart); return; }
    var ua = t.closest('[data-og-up-add]');
    if (ua) { addToCart(parseInt(ua.getAttribute('data-og-up-add'), 10), 1, ua, fetchCart); return; }
    if (t.closest('[data-og-up-prev]')) { var r1 = q('[data-og-up-rail]', drawer); if (r1) r1.scrollBy({ left: -172 }); return; }
    if (t.closest('[data-og-up-next]')) { var r2 = q('[data-og-up-rail]', drawer); if (r2) r2.scrollBy({ left: 172 }); return; }
    var sticky = t.closest('[data-og-sticky-atc]');
    if (sticky) { e.preventDefault(); var sel = q('[data-og-product] [name="id"]'); addToCart(sel ? parseInt(sel.value, 10) : 0, 1, sticky); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) openCart(false);
    toggleMenu(false);
    var sg = q('.og-sg'); if (sg) sg.classList.remove('is-open');
    var tz = q('[data-og-tote]'); if (tz) tz.classList.remove('is-open');
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-og-form]');
    if (!f) return;
    e.preventDefault();
    var id = q('[name="id"]', f);
    if (!id || !id.value) return;
    var sub = e.submitter, buy = sub && sub.hasAttribute('data-og-buy');
    if (buy) { sub.setAttribute('data-og-prev', sub.textContent); sub.classList.add('is-buying'); sub.textContent = 'TAKING YOU TO CHECKOUT\u2026'; }
    var pr = f.closest('[data-og-product]');
    addToCart(parseInt(id.value, 10), 1, buy ? sub : q('[data-og-atc]', f), buy ? function () { fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(syncTotes).catch(function () {}).then(function () { return savePlan(pr); }).then(function () { ogGoCheckout(sub); }); } : function () { savePlan(pr); openCart(true); });
  });

  function ogGoCheckout(btn) {
    var tries = 0;
    function reset() { if (!btn) return; btn.classList.remove('is-buying'); btn.textContent = btn.getAttribute('data-og-prev') || 'BUY NOW'; }
    (function attempt() {
      var sdk = window.gokwikSdk || window.__gkSdkCache;
      if (sdk && typeof sdk.initCheckout === 'function' && window.merchantInfo) {
        try { if (window.ogCart) window.ogCart.close(); } catch (e) {}
        try { sdk.initCheckout(window.merchantInfo); setTimeout(reset, 2500); return; } catch (e) {}
      }
      if (tries++ < 24) { setTimeout(attempt, 250); return; }
      window.location.href = '/checkout';
    })();
  }

  function boot() {
    bindGuide(); bindStickyAtc(); bindTote();
    qa('[data-og-product]').forEach(function (root) { bindVariants(root); bindPay(root); });
    bindSlider(q('.og-gal__shots'), q('.og-gal__n'), q('.og-gal__dots'));
    qa('[data-og-wear]').forEach(bindWear);
    if (drawer) fetchCart();
    window.addEventListener('resize', function () { if (window.innerWidth >= 1000) lock(drawer && drawer.classList.contains('is-open')); });
    document.addEventListener('shopify:section:load', function () { qa('[data-og-wear]').forEach(function (w) { if (!w.dataset.ogBound) { w.dataset.ogBound = '1'; bindWear(w); } }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
